import * as actions from "./actions";

const initialState = {
	loading: { create: false },
	errors: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.CREATE_TAX: {
			return {
				...state,
				loading: { create: true }
			};
		}
		case actions.CREATE_TAX_SUCCESS: {
			return {
				...state,
				loading: { create: false },
				errors: {}
			};
		}
		case actions.CREATE_TAX_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { create: false }
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
